/* Forbo Bulletin Board sample chart — DRAFT rev 2026-10-07b
   Shopify's own cart is the only cart. Every mutation goes through /cart/add.js,
   /cart/change.js, /cart/update.js and /cart.js. Nothing is stored client-side as
   a substitute for the cart; localStorage is used only to pre-fill the
   questionnaire inputs so a returning shopper does not retype answers.

   NOTE ON ENFORCEMENT: the checkout gate implemented here is FRONT-END ONLY and
   is NOT sufficient for production. See snippets/forbo-checkout-guard.liquid and
   the delivery notes for the Shopify mechanism actually required.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-forbo-samples]');
  if (!root) return;

  var LS_KEY = 'cart-questions-BID'; // same key the existing live block uses
  var NOTE_OPEN = '[FORBO PROJECT INFO]';
  var NOTE_CLOSE = '[/FORBO PROJECT INFO]';

  var PRODUCT_ID = String(root.getAttribute('data-product-id') || '');

  /* rev 2026-10-11: the sample experience now spans 12 Forbo products, so a cart
     line belongs to it when its product is ANY line in the navigation -- not only
     the one being viewed. Without this, samples picked on the Fresco page show up
     as "other items in your cart" on the Walton page and the checkout gate stops
     seeing them. data-lines is written by the section from its own blocks, so the
     set is exactly the configured navigation and nothing wider. */
  var LINE_IDS = {};
  var LINE_NAMES = {};
  (function () {
    var raw = root.getAttribute('data-lines') || '[]';
    var arr = [];
    try { arr = JSON.parse(raw) || []; } catch (e) { arr = []; }
    for (var i = 0; i < arr.length; i++) {
      if (!arr[i] || arr[i].id == null) continue;
      var k = String(arr[i].id);
      LINE_IDS[k] = true;
      LINE_NAMES[k] = String(arr[i].label == null ? '' : arr[i].label);
    }
    if (PRODUCT_ID) LINE_IDS[PRODUCT_ID] = true;   // the viewed product always counts
  }());
  function isLine(id) { return LINE_IDS[String(id)] === true; }
  var CURRENCY = root.getAttribute('data-currency') || 'USD';
  var MAX_PER_COLOR = parseInt(root.getAttribute('data-max-per-color') || '0', 10); // 0 = no cap
  var GATE_MSG = root.getAttribute('data-gate-message') || '';

  var quiz = root.querySelector('[data-forbo-quiz]');
  var fields = Array.prototype.slice.call(root.querySelectorAll('[data-forbo-field]'));
  var savedNote = root.querySelector('[data-forbo-saved]');
  var tray = root.querySelector('[data-forbo-tray]');   // now inside the dialog
  var trayItems = root.querySelector('[data-forbo-items]');
  var trayEmpty = root.querySelector('[data-forbo-empty]');
  var trayCount = root.querySelector('[data-forbo-count]');
  var traySub = root.querySelector('[data-forbo-subtotal]');
  var trayOther = root.querySelector('[data-forbo-other]');
  var blockBox = root.querySelector('[data-forbo-block]');
  var statusEls = Array.prototype.slice.call(root.querySelectorAll('[data-forbo-status]'));
  var barCount = root.querySelector('[data-forbo-bar-count]');
  var barStatus = root.querySelector('[data-forbo-bar-status]');
  var bar = root.querySelector('[data-forbo-bar]');
  var live = root.querySelector('[data-forbo-live]');
  // rev b: the tray lives in the dialog, so these buttons are the only way to
  // reach it without first picking a colour. They open the SAME dialog in
  // cart-only mode -- there is no second cart and no second markup.
  var openCartBtns = Array.prototype.slice.call(root.querySelectorAll('[data-forbo-open-cart]'));
  var openCartN = root.querySelector('[data-forbo-open-cart-n]');

  var dlg = root.querySelector('[data-forbo-dialog]');
  var dlgImg = dlg.querySelector('[data-forbo-dlg-img]');
  var dlgNum = dlg.querySelector('[data-forbo-dlg-num]');
  var dlgTitle = dlg.querySelector('[data-forbo-dlg-title]');
  var dlgPrice = dlg.querySelector('[data-forbo-dlg-price]');
  var dlgAvail = dlg.querySelector('[data-forbo-dlg-avail]');
  var dlgQty = dlg.querySelector('[data-forbo-dlg-qty]');
  var dlgMinus = dlg.querySelector('[data-forbo-dlg-minus]');
  var dlgPlus = dlg.querySelector('[data-forbo-dlg-plus]');
  var dlgAdd = dlg.querySelector('[data-forbo-dlg-add]');
  var dlgMsg = dlg.querySelector('[data-forbo-dlg-msg]');
  var dlgBack = dlg.querySelector('[data-forbo-dlg-back]');
  var dlgClose = dlg.querySelector('.forbo-dialog__close');

  var current = null;  // the tile whose dialog is open
  var cart = null;     // last known /cart.js payload
  var chain = Promise.resolve(); // serialises cart writes so taps cannot interleave
  var inflight = Object.create(null);
  var noteTimer = null;

  /* ---------------------------------------------------------------- helpers */

  function fmt(cents) {
    var n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function say(msg) {
    if (live) live.textContent = msg || '';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var err = new Error((data && (data.description || data.message)) || ('Request failed (' + r.status + ')'));
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function queue(fn) {
    chain = chain.then(fn, fn);
    return chain;
  }

  /* ------------------------------------------------------------ questionnaire */

  function answers() {
    var out = [];
    fields.forEach(function (f) {
      var input = f.querySelector('input, textarea');
      if (!input) return;
      out.push({
        field: f,
        input: input,
        key: f.getAttribute('data-attr'),
        label: f.getAttribute('data-label') || '',
        required: f.getAttribute('data-required') === '1',
        value: (input.value || '').trim()
      });
    });
    return out;
  }

  function missing() {
    return answers().filter(function (a) { return a.required && !a.value; });
  }

  function complete() {
    return missing().length === 0;
  }

  function loadSaved() {
    var raw;
    try { raw = localStorage.getItem(LS_KEY); } catch (e) { return; }
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw); } catch (e) { return; }
    if (!data || typeof data !== 'object') return;
    // Server cart attributes win over localStorage; this only fills blanks.
    answers().forEach(function (a) {
      if (a.input.value) return;
      var v = data[a.key];
      if (v == null) v = data[a.label];
      if (typeof v === 'string' && v.trim()) a.input.value = v;
    });
  }

  function saveLocal() {
    var data = {};
    answers().forEach(function (a) { data[a.key] = a.value; });
    try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (e) { /* private mode */ }
  }

  // Keeps the Q1:/A1: note format the existing ops tooling already parses, but
  // fenced in sentinels so a shopper's own note text is never destroyed.
  function buildNote(existing) {
    var keep = existing || '';
    var a = keep.indexOf(NOTE_OPEN);
    var b = keep.indexOf(NOTE_CLOSE);
    if (a !== -1 && b !== -1 && b > a) {
      keep = (keep.slice(0, a) + keep.slice(b + NOTE_CLOSE.length)).trim();
    }
    var lines = [];
    var n = 1;
    answers().forEach(function (x) {
      if (!x.value) return;
      lines.push('Q' + n + ': ' + x.label);
      lines.push('A' + n + ': ' + x.value);
      lines.push('----------------------------');
      n++;
    });
    if (!lines.length) return keep;
    var blockText = NOTE_OPEN + '\n' + lines.join('\n') + '\n' + NOTE_CLOSE;
    return keep ? (blockText + '\n\n' + keep) : blockText;
  }

  function pushQuestionnaire() {
    saveLocal();
    var attrs = {};
    answers().forEach(function (a) { attrs[a.key] = a.value; });
    attrs['Forbo project - questionnaire status'] = complete() ? 'complete' : 'incomplete';
    var note = buildNote(cart ? cart.note : '');
    return queue(function () {
      return postJSON('/cart/update.js', { attributes: attrs, note: note })
        .then(function (c) {
          cart = c;
          if (savedNote) savedNote.textContent = complete()
            ? 'Project information saved to your order.'
            : 'Answers saved as you type.';
          render();
        })
        .catch(function (e) {
          if (savedNote) savedNote.textContent = 'Could not save answers: ' + e.message;
        });
    });
  }

  function onInput() {
    // Clear the "missing" highlight the moment the shopper starts fixing it.
    fields.forEach(function (f) {
      var input = f.querySelector('input, textarea');
      if (input && (input.value || '').trim()) f.removeAttribute('data-missing');
    });
    paintStatus();
    clearTimeout(noteTimer);
    noteTimer = setTimeout(pushQuestionnaire, 700);
  }

  function flagMissing(focus) {
    var miss = missing();
    fields.forEach(function (f) { f.removeAttribute('data-missing'); });
    miss.forEach(function (m) { m.field.setAttribute('data-missing', '1'); });
    if (focus && miss.length) {
      if (quiz && quiz.scrollIntoView) quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try { miss[0].input.focus({ preventScroll: true }); } catch (e) { miss[0].input.focus(); }
      say(miss.length + ' required question' + (miss.length === 1 ? '' : 's') + ' still need an answer.');
    }
    return miss;
  }

  function paintStatus() {
    var ok = complete();
    var miss = missing().length;
    statusEls.forEach(function (el) {
      el.className = 'forbo-status ' + (ok ? 'forbo-status--ok' : 'forbo-status--todo');
      el.textContent = ok
        ? 'Project information complete'
        : (miss + ' required question' + (miss === 1 ? '' : 's') + ' remaining');
    });
    if (barStatus) {
      barStatus.setAttribute('data-ok', ok ? '1' : '0');
      barStatus.textContent = ok ? 'Project info complete' : 'Project info needed';
    }
    if (blockBox) blockBox.hidden = ok || !forboLines().length;
  }

  /* -------------------------------------------------------------------- cart */

  function forboLines() {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (i) { return isLine(i.product_id); });
  }

  function otherLines() {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (i) { return !isLine(i.product_id); });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  function hydrateFromCart() {
    if (!cart || !cart.attributes) return;
    // The server cart is authoritative for answers: it is what ops will read.
    answers().forEach(function (a) {
      var v = cart.attributes[a.key];
      if (typeof v === 'string' && v.trim()) a.input.value = v;
    });
  }

  function addSample(variantId, qty) {
    var id = String(variantId);
    if (inflight[id]) return Promise.resolve(null); // duplicate tap
    inflight[id] = true;
    var attrs = {};
    answers().forEach(function (a) { if (a.value) attrs[a.key] = a.value; });
    attrs['Forbo project - questionnaire status'] = complete() ? 'complete' : 'incomplete';
    return queue(function () {
      return postJSON('/cart/add.js', {
        items: [{
          id: Number(variantId),
          quantity: qty,
          properties: { '_forbo_sample': '1' }
        }],
        attributes: attrs
      }).then(function () {
        return fetchCart();
      });
    }).then(function (c) {
      delete inflight[id];
      render();
      return c;
    }).catch(function (e) {
      delete inflight[id];
      throw e;
    });
  }

  function setLine(key, qty) {
    if (inflight['line:' + key]) return Promise.resolve(null);
    inflight['line:' + key] = true;
    return queue(function () {
      return postJSON('/cart/change.js', { id: key, quantity: qty });
    }).then(function (c) {
      cart = c;
      delete inflight['line:' + key];
      render();
      return c;
    }).catch(function (e) {
      delete inflight['line:' + key];
      say('Could not update the cart: ' + e.message);
      throw e;
    });
  }

  /* ------------------------------------------------------------------ render */

  // The theme paints its own cart badges server-side and only refreshes them on
  // its own jQuery cart writes. Our adds go through /cart/add.js, so without
  // this the header and the sticky bar keep showing the pre-add count until the
  // next full page load. Repaint them from the authoritative /cart.js payload.
  function syncThemeBadges() {
    if (!cart) return;
    var count = String(cart.item_count == null ? '' : cart.item_count);
    ['#fcCount', '.float_count'].forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
        if (!el.children.length) el.textContent = count;
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('#fcTotal'), function (el) {
      if (!el.children.length) el.textContent = fmt(cart.total_price);
    });
  }

  function render() {
    syncThemeBadges();
    var lines = forboLines();
    var units = 0, subtotal = 0;
    lines.forEach(function (l) { units += l.quantity; subtotal += l.final_line_price; });

    // per-tile badges
    var byVariant = Object.create(null);
    lines.forEach(function (l) { byVariant[String(l.variant_id)] = (byVariant[String(l.variant_id)] || 0) + l.quantity; });
    Array.prototype.forEach.call(root.querySelectorAll('[data-forbo-tile]'), function (t) {
      var n = byVariant[t.getAttribute('data-variant')] || 0;
      var badge = t.querySelector('[data-forbo-tile-count]');
      if (badge) {
        badge.hidden = n === 0;
        badge.textContent = n ? String(n) : '';
      }
      // Keep the colour number: the server-rendered label and the visible tile
      // both read "2210 Hot salsa", so the re-render must not drop the number.
      var nm = ((t.getAttribute('data-num') || '') + ' ' + (t.getAttribute('data-colorname') || '')).trim();
      t.setAttribute('aria-label', nm + (n ? (', ' + n + ' in cart') : '') + ' — view sample and add to cart');
    });

    if (trayCount) {
      trayCount.textContent = lines.length
        ? (units + ' sample' + (units === 1 ? '' : 's') + ' · ' + lines.length + ' color' + (lines.length === 1 ? '' : 's'))
        : 'No samples selected yet';
    }
    if (barCount) {
      barCount.textContent = units
        ? (units + ' sample' + (units === 1 ? '' : 's') + ' · ' + fmt(subtotal))
        : 'No samples yet';
    }
    if (openCartN) openCartN.textContent = String(units);
    openCartBtns.forEach(function (b) {
      // Nothing to review until something is actually in the Shopify cart.
      if (b.classList.contains('forbo-bar__btn')) return;   // the mobile bar owns its own visibility
      b.hidden = units === 0;
    });

    if (traySub) traySub.textContent = fmt(subtotal);
    if (trayEmpty) trayEmpty.hidden = lines.length > 0;

    if (trayItems) {
      trayItems.textContent = '';
      lines.forEach(function (l) {
        var li = document.createElement('li');
        li.className = 'forbo-tray__item';

        var img = document.createElement('img');
        img.className = 'forbo-tray__thumb';
        img.width = 48; img.height = 48; img.loading = 'lazy'; img.decoding = 'async';
        img.src = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, '_96x96$1$2') : '';
        img.alt = '';
        li.appendChild(img);

        var body = document.createElement('div');

        var nm = document.createElement('div');
        nm.className = 'forbo-tray__nm';
        nm.textContent = (l.variant_title || l.product_title || '')
          .replace(/^Samples?\s*\/\s*/i, '');   // MCS's size option reads "Samples"
        body.appendChild(nm);

        /* Which line this colour came from. Real and MCS both ship 3032 Mist Grey,
           so a cross-line cart needs more than the colour number. */
        var lineNm = LINE_NAMES[String(l.product_id)];
        if (lineNm) {
          var ld = document.createElement('div');
          ld.className = 'forbo-tray__line';
          ld.textContent = lineNm;
          body.insertBefore(ld, nm);
        }

        var ln = document.createElement('div');
        ln.className = 'forbo-tray__ln';
        ln.textContent = l.quantity + ' × ' + fmt(l.final_price) + ' = ' + fmt(l.final_line_price);
        body.appendChild(ln);

        var ctl = document.createElement('div');
        ctl.className = 'forbo-tray__ctl';

        var qwrap = document.createElement('div');
        qwrap.className = 'forbo-qty forbo-qty--sm';
        var dec = document.createElement('button');
        dec.type = 'button'; dec.textContent = '−';
        dec.setAttribute('aria-label', 'Decrease quantity of ' + nm.textContent);
        var inp = document.createElement('input');
        inp.type = 'text'; inp.inputMode = 'numeric'; inp.value = String(l.quantity);
        inp.setAttribute('aria-label', 'Quantity of ' + nm.textContent);
        var inc = document.createElement('button');
        inc.type = 'button'; inc.textContent = '+';
        inc.setAttribute('aria-label', 'Increase quantity of ' + nm.textContent);
        if (MAX_PER_COLOR > 0 && l.quantity >= MAX_PER_COLOR) inc.disabled = true;

        dec.addEventListener('click', function () { setLine(l.key, Math.max(0, l.quantity - 1)); });
        inc.addEventListener('click', function () { setLine(l.key, l.quantity + 1); });
        inp.addEventListener('change', function () {
          var v = parseInt(inp.value, 10);
          if (isNaN(v) || v < 0) { inp.value = String(l.quantity); return; }
          if (MAX_PER_COLOR > 0 && v > MAX_PER_COLOR) v = MAX_PER_COLOR;
          setLine(l.key, v);
        });
        qwrap.appendChild(dec); qwrap.appendChild(inp); qwrap.appendChild(inc);
        ctl.appendChild(qwrap);

        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'forbo-tray__rm';
        rm.textContent = 'Remove';
        rm.setAttribute('aria-label', 'Remove ' + nm.textContent + ' from cart');
        rm.addEventListener('click', function () {
          var label = nm.textContent;
          setLine(l.key, 0).then(function () { say(label + ' removed.'); });
        });
        ctl.appendChild(rm);

        body.appendChild(ctl);
        li.appendChild(body);
        trayItems.appendChild(li);
      });
    }

    if (trayOther) {
      var others = otherLines();
      trayOther.hidden = others.length === 0;
      if (others.length) {
        var oc = 0;
        others.forEach(function (o) { oc += o.quantity; });
        trayOther.textContent = 'Your cart also holds ' + oc + ' other item' + (oc === 1 ? '' : 's') +
          ' (' + fmt(cart.total_price - subtotal) + '). Those are untouched by this page.';
      }
    }

    if (bar) bar.hidden = false;
    paintStatus();
  }

  /* ------------------------------------------------------------------ dialog */

  // Opens the dialog showing only the sample cart -- same dialog, same tray,
  // same /cart.js data, with the colour pane hidden.
  function openCartOnly() {
    current = null;
    dlg.setAttribute('data-cartonly', '1');
    dlg.setAttribute('aria-labelledby', 'forbo-tray-title');
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    try { if (dlgClose) dlgClose.focus({ preventScroll: true }); } catch (e) {}
    render();
  }

  function openDialog(tile) {
    current = tile;
    dlg.removeAttribute('data-cartonly');
    dlg.setAttribute('aria-labelledby', 'forbo-dlg-title');
    var num = tile.getAttribute('data-num') || '';
    var name = tile.getAttribute('data-colorname') || '';
    var avail = tile.getAttribute('data-available') === '1';

    dlgNum.textContent = num;
    dlgTitle.textContent = name;
    dlgPrice.textContent = tile.getAttribute('data-price-formatted') || '';
    dlgAvail.setAttribute('data-ok', avail ? '1' : '0');
    dlgAvail.textContent = avail ? 'Available to order as a sample' : 'Currently unavailable';
    dlgMsg.textContent = '';
    dlgMsg.removeAttribute('data-kind');
    dlgBack.hidden = false;   // a way out of the modal must exist from the start
    dlgQty.value = '1';
    dlgMinus.disabled = true;
    dlgPlus.disabled = MAX_PER_COLOR === 1;
    dlgAdd.disabled = !avail;
    dlgAdd.textContent = 'Add sample to cart';

    var big = tile.getAttribute('data-image-large');
    if (big) {
      dlgImg.hidden = false;
      dlgImg.src = big;
      dlgImg.alt = tile.getAttribute('data-image-alt') || (name + ' Forbo Bulletin Board sample');
    } else {
      dlgImg.hidden = true;
      dlgImg.removeAttribute('src');
    }

    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    try { dlgQty.focus({ preventScroll: true }); } catch (e) {}
  }

  function stepQty(delta) {
    var v = parseInt(dlgQty.value, 10);
    if (isNaN(v)) v = 1;
    v += delta;
    if (v < 1) v = 1;
    if (MAX_PER_COLOR > 0 && v > MAX_PER_COLOR) v = MAX_PER_COLOR;
    dlgQty.value = String(v);
    dlgMinus.disabled = v <= 1;
    dlgPlus.disabled = MAX_PER_COLOR > 0 && v >= MAX_PER_COLOR;
  }

  dlgMinus.addEventListener('click', function () { stepQty(-1); });
  dlgPlus.addEventListener('click', function () { stepQty(1); });
  dlgQty.addEventListener('change', function () { stepQty(0); });

  dlgAdd.addEventListener('click', function () {
    if (!current || dlgAdd.disabled) return;
    var tile = current;
    var vid = tile.getAttribute('data-variant');
    var qty = parseInt(dlgQty.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    var name = tile.getAttribute('data-colorname') || 'Sample';

    dlgAdd.disabled = true;
    dlgAdd.textContent = 'Adding…';
    dlgMsg.removeAttribute('data-kind');
    dlgMsg.textContent = '';

    addSample(vid, qty).then(function (c) {
      if (c === null) return; // duplicate tap swallowed
      dlgMsg.setAttribute('data-kind', 'ok');
      dlgMsg.textContent = 'Added ' + qty + ' × ' + name + ' to your cart.';
      dlgBack.hidden = false;
      say('Added ' + qty + ' ' + name + ' sample' + (qty === 1 ? '' : 's') + ' to your cart.');
    }).catch(function (e) {
      dlgMsg.setAttribute('data-kind', 'err');
      dlgMsg.textContent = e.message || 'Could not add this sample.';
      say('Could not add ' + name + '. ' + (e.message || ''));
    }).then(function () {
      dlgAdd.disabled = tile.getAttribute('data-available') !== '1';
      dlgAdd.textContent = 'Add sample to cart';
    });
  });

  dlg.addEventListener('close', function () { current = null; dlg.removeAttribute('data-cartonly'); });

  // Click on the backdrop closes. Escape and the X button are handled natively.
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) dlg.close();
  });

  /* ------------------------------------------------------- tiles + checkout */

  Array.prototype.forEach.call(root.querySelectorAll('[data-forbo-tile]'), function (tile) {
    tile.addEventListener('click', function () { openDialog(tile); });
  });

  fields.forEach(function (f) {
    var input = f.querySelector('input, textarea');
    if (!input) return;
    input.addEventListener('input', onInput);
    input.addEventListener('blur', function () { clearTimeout(noteTimer); pushQuestionnaire(); });
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-forbo-goto-quiz]'), function (btn) {
    btn.addEventListener('click', function () {
      // The questions are on the page, not in the dialog, so close the dialog
      // first -- otherwise the scroll-and-focus happens behind the backdrop.
      if (dlg.open) dlg.close();
      flagMissing(true);
    });
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-forbo-checkout]'), function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!forboLines().length) {
        say('Add at least one sample before checking out.');
        return;
      }
      if (!complete()) {
        e.stopPropagation();
        if (blockBox) blockBox.hidden = false;
        // With the dialog open the warning and its "Complete Project Questions"
        // action are already on screen inside the modal; scrolling the page
        // behind the backdrop would just hide them.
        flagMissing(!dlg.open);
        say(GATE_MSG);
        return;
      }
      // Complete: flush the answers, then hand off to Shopify's own checkout.
      btn.disabled = true;
      pushQuestionnaire().then(function () { window.location.href = '/checkout'; })
        .catch(function () { btn.disabled = false; });
    });
  });

  openCartBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { openCartOnly(); });
  });

  /* ------------------------------------------------------------ lazy images */

  var lazies = Array.prototype.slice.call(root.querySelectorAll('img[data-lazy]'));
  function show(img) {
    if (img.dataset.src) img.src = img.dataset.src;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.removeAttribute('data-lazy');
  }
  if ('IntersectionObserver' in window && lazies.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        show(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: '300px 0px' });
    lazies.forEach(function (i) { io.observe(i); });
  } else {
    lazies.forEach(show);
  }

  /* -------------------------------------------------------------------- boot */

  fetchCart().then(function () {
    hydrateFromCart();
    loadSaved();
    render();
    // If localStorage supplied answers the server cart does not have yet, persist them.
    var hasLocalOnly = answers().some(function (a) {
      return a.value && (!cart.attributes || cart.attributes[a.key] !== a.value);
    });
    if (hasLocalOnly) pushQuestionnaire();
  }).catch(function () {
    loadSaved();
    paintStatus();
  });
})();
